import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext"; // Importa tu contexto

const ForgotPasswordModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // 'idle', 'loading', 'success', 'error'
  const { resetPassword } = useAuth(); // Asume que tienes esta función en tu AuthContext

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await resetPassword(email);
      setStatus("success");
    } catch (err) {
      setStatus("error");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm">
      <div className="bg-white p-8 rounded-3xl max-w-sm w-full shadow-2xl">
        <h2 className="text-2xl font-black text-slate-800 mb-4">
          ¿Olvidaste tu contraseña?
        </h2>

        {status === "success" ? (
          <div className="text-center py-4">
            <p className="text-green-600 font-bold mb-4">
              ¡Correo enviado con éxito!
            </p>
            <button
              onClick={onClose}
              className="w-full py-3 bg-slate-100 rounded-xl font-bold"
            >
              Cerrar
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-slate-500 text-sm">
              Introduce tu correo y te enviaremos instrucciones para
              restablecerla.
            </p>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com"
              className="w-full p-3 border-2 border-slate-200 rounded-xl"
              required
            />
            <button
              type="submit"
              disabled={status === "loading"}
              className="w-full py-3 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition-colors"
            >
              {status === "loading" ? "Enviando..." : "Enviar enlace"}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="w-full text-slate-400 text-sm"
            >
              Cancelar
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
